import {createFileRoute} from '@tanstack/react-router'

import {Authorisation} from "@/lib/auth/components/auth-provider";
import Unauthorized from "@/lib/auth/components/unauthorized";
import {ROLES} from "@/lib/auth/roles";
import EnquiryPage from "@/modules/enquiries/enquiry";
import {ENQUIRY_PATH} from "@/utils/urls";

export const Route = createFileRoute(ENQUIRY_PATH)({
  component: Enquiry,
  loader: async ({params}) => {
    const {id} = params
    return {id}
  },
  beforeLoad: ({params}) => {
    return {
      breadcrumbs: [
        {label: 'Enquiries', path: '/v2/enquiries'},
        {label: `${params.id}`, path: `/v2/enquiries/${params.id}`}
      ],
      children: null,
      canSwitchFirm: false
    }
  },
})

function Enquiry() {
  return (
    <Authorisation roles={[ROLES.ROLE_EDIT_ENQUIRIES]} permissions={[]} forbiddenFallback={<Unauthorized/>}>
      <div className={'flex flex-col items-left justify-center max-sm:p-5'}>
        <EnquiryPage/>
      </div>
    </Authorisation>
  )
}
